import styled, { css } from 'styled-components';

import Place1 from '@assets/images/promotions/place1.webp';
import Place2 from '@assets/images/promotions/place2.webp';
import Place3 from '@assets/images/promotions/place3.webp';
import endedBG from '@assets/images/promotions/promo_ended_card.webp';

export const Wrapper = styled.div<{ $place?: number | null }>`
	width: 403px;
	padding: 16px;
	border-radius: 12px;
	background-color: ${({ theme }) => theme.colors.background.secondary};

	position: relative;
	overflow: hidden;

	display: flex;
	height: 100%;
	flex-direction: column;
	justify-content: space-between;

	background-image: url('${endedBG}');
	background-position: right;
	background-size: cover;
	background-repeat: no-repeat;

	${({ $place }) =>
		$place === 1
			? css`
					background-image: url('${Place1}');
				`
			: $place === 2
				? css`
						background-image: url('${Place2}');
					`
				: $place === 3
					? css`
							background-image: url('${Place3}');
						`
					: ''}
`;

export const ChipWrapper = styled.div`
	display: flex;
	gap: 8px;
	align-items: center;
	margin-bottom: 8px;
`;

export const WinnerCount = styled.div`
	font-size: 14px;
	line-height: 19px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
`;

export const Chip = styled.div`
	padding: 4px 6px;
	font-size: 12px;
	line-height: 16px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.control.light};

	border-radius: 16px;
	background-color: ${({ theme }) => theme.colors.transparent.light10};
`;

export const Title = styled.h3`
	font-size: 16px;
	line-height: 22px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};

	margin-bottom: 8px;

	max-width: 250px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const Prize = styled.p`
	font-size: 14px;
	line-height: 19px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};

	margin-bottom: 4px;
`;

export const PrizeName = styled.div`
	font-size: 16px;
	line-height: 22px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.title};
	margin-bottom: 8px;

	display: flex;
	align-items: center;
	gap: 4px;
`;

export const CupIconWrapper = styled.div`
	width: 16px;
	height: 16px;

	svg {
		width: 16px;
		height: 16px;
	}

	path {
		fill: ${({ theme }) => theme.colors.icon.main};
	}
`;

export const ButtonWrapper = styled.div`
	display: flex;
	gap: 8px;
`;
